import { authenticatedFetch } from './base'

/**
 * Get terms for certain circle in certain language
 *
 * @param {number} circleId - circle ID
 * @param {string} language - language name
 * @returns {*} - response containing terms for the circle and 3rd party terms if any
 */
export const fetchTerms = (circleId, language) => {
	var url = `/api/terms/circle/${circleId}/language/${language}`

	return authenticatedFetch(url, { method: 'GET' })
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(terms) {
			return terms
		})
}

/**
 * Get terms for certain patient in certain language by patient's email
 *
 * @param {string} email - patient's email
 * @param {string} language - language name
 * @returns {*} - response containing terms for patient's circle and 3rd party terms if any
 */
export const fetchTermsByPatientEmail = (email, language) => {
    var encodedEmail = encodeURIComponent(email)
	var url = `/api/terms/patientEmail/${encodedEmail}/language/${language}`

	return fetch(url, { method: 'GET' })
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(terms) {
			return terms
		})
}

/**
 * Get patient accepted terms by terms' ID
 *
 * @param {number} id - terms ID
 * @returns {*} - response containing terms and acceptance date
 */
export const fetchTerm = (id) => {
	return authenticatedFetch(`/api/terms/${id}`, { method: 'GET' })
        .then(function (response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function (term) {
            return term
        })
}

/**
 * Check if last circle's terms have been accepted by the patient
 *
 * @param {number} patientId - patient ID
 * @returns {*} - response indicating if the terms have been accepted
 */
export const fetchIsCircleTermsAccepted = (patientId) => {
	return authenticatedFetch(`/api/terms/patient/${patientId}/isCircleTermsAccepted`, { method: 'GET' })
        .then(function (response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function (term) {
            return term
        })
}

/**
 * Accept terms for certain circle and patient
 *
 * @param {number} circleId - circle ID
 * @param {number} patientId - patient ID
 * @returns {*} - response indicating if the action was successful
 */
export const fetchAcceptCircleTerms = (circleId, patientId) => {
	return authenticatedFetch(`/api/terms/patient/${patientId}/circle/${circleId}/acceptCircleTerms`, { method: 'PUT' })
        .then(function (response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function (term) {
            return term
        })
}
